export default __webpack_public_path__ + "7d0a2c4167585f86be8baa88fb62272a.svg";